import React, { useState } from "react";
import "./needHelp.scss";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NeedHelp = () => {

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
  });

  const [formErrors, setFormErrors] = useState({
    username: "",
    email: "",
    phone: "",
  });

  const showToast = (message) => {
    toast.error(message, {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  const handleInputChange = (field, value) => {
  

    setFormData({
      ...formData,
      [field]: value,
    });
    // Clear errors when the user starts typing
    setFormErrors({
      ...formErrors,
      [field]: "",
    });
  };

  const handleSignup = () => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const { username, email, phone } = formData;
    const newFormErrors = {};

    if (!username || !email || !phone) {
      showToast("Fields are empty");
      return;
    }

    if (!emailRegex.test(email)) {
      showToast("Invalid Email Format");
      return;
     
    }

    if (formData.phone.length !== 11) {
     showToast("Phone number must be 11 digits");
     return;
    }

    setFormErrors(newFormErrors);
    // Perform your sign-up logic here if there are no errors
    if (Object.keys(newFormErrors).length === 0) {
      alert("Sign up successful!");
      // navigate("/plan");
    }
  };
  return (
    <div className="needHelpContainer">
      <div className="needHelpMainDiv">
        <div className="left-content">
          <div className="leftContentData">
            <h4>
              Get in <span>Touch</span>
            </h4>
            <p className="stateIssue">State your issue</p>
            <input
              type="text"
              value={formData.username}
              onChange={(e) => handleInputChange("username", e.target.value)}
              placeholder="Name *"
              style={{
                border: formErrors.username
                  ? "1px solid red"
                  : "1px solid #ccc",
              }}
            />
            <input
              type="email"
              name=""
              value={formData.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              style={{
                border: formErrors.email ? "1px solid red" : "1px solid #ccc",
              }}
              id=""
              placeholder="Email"
            />
          

            <input
              type="number"
              name=""
              id=""
              value={formData.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
              placeholder="Phone Number *"
              style={{
                border: formErrors.phone ? "1px solid red" : "1px solid #ccc",
              }}
            />

         

            <input type="text" name="" id="" placeholder="Your Issue" />
            <button className="send-btn" onClick={handleSignup}>
              Send
            </button>
            <div className="contactMediaWrapper">
              <div className="phoneDiv">
                {/* <img className='phoneIcon' src="/images/Dashboard/phoneIcon.png" alt="..." /> */}
                <p>PHONE</p>
                <span>03 4532 1234</span>
              </div>

              <div className="faxDiv">
                <p>FAX</p>
                <span>03 4532 1234</span>
              </div>

              <div className="emailDiv">
                <p>EMAIL</p>
                <span>03 4532 1234</span>
              </div>
            </div>
          </div>
        </div>
        <div className="right-content">
          <img
            src="
                /images/Dashboard/needHelpImg.png"
            alt="..."
          />
        </div>
      </div>
    </div>
  );
};

export default NeedHelp;
